<div class="container-fluid tw-bg-gradient-to-b tw-from-[#1a1a2e] tw-to-[#16213e] tw-pb-12">
    <!-- Encabezado -->
    <div class="tw-max-w-5xl tw-mx-auto tw-px-4">
      <h2 class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight">
        <span class="tw-text-white">
          CONÉCTATE A <span class="tw-text-[#F67011] tw-drop-shadow-md">NUESTROS PLANES</span> DE FIBRA
        </span>
      </h2>
      
      <div class="tw-h-1 tw-bg-gradient-to-r tw-from-transparent tw-via-[#F67011] tw-to-transparent tw-w-3/4 tw-mx-auto tw-my-4"></div>
      
      <p class="tw-text-center tw-text-lg tw-font-montserrat tw-font-light tw-text-gray-200 tw-mt-2 tw-mb-8  tw-leading-relaxed">
        <span class="tw-text-[#F67011] tw-font-bold"> Onelink</span> ofrece <span class="tw-font-medium tw-text-white">un servicio prepago y sin complicaciones, sin cláusulas</span>,ni cargos ocultos para reactivar tu conexión, con planes asimétricos diseñados para una experiencia optimizada.
        <span class="tw-block md:tw-inline">Garantizando entre el <span class="tw-text-[#F67011]">60% y el 90%</span> de la velocidad contratada.</span>
      </p>
    </div>
  
    <!-- Grid de tarjetas -->
    <div class="tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-2">
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-2 tw-gap-6 tw-mt-4">
        <app-card-price  [plan]="'500'" [price]="'30'"></app-card-price>
        <app-card-price [plan]="'800'" [price]="'38'"></app-card-price>
        <app-card-price [plan]="'900'" [price]="'52'"></app-card-price>
        <app-card-price [plan]="'1500'" [price]="'88'"></app-card-price>
      </div>
    </div>
  
   
  </div>